import { useState } from "react";
import "../dashboard/AnalyticsDashboard.css";
import { DashboardTopbar } from "../components/DashboardTopbar";
import {
  FaChevronDown,
  FaChevronRight,
  FaChevronLeft,
  FaDownload,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaSlidersH,
  FaUsers,
  FaBrain,
  FaHeartbeat,
  FaLungs,
  FaVenus,
  FaRibbon,
  FaTint,
  FaWheelchair,
  FaBone,
  FaBabyCarriage,
  FaEye,
  FaAssistiveListeningSystems,
  FaVenusMars,
  FaArrowUp,
  FaArrowDown,
  FaEllipsisH,
  FaMale,
  FaFemale,
  FaVirus,
} from "react-icons/fa";
import { GiBrain, GiKidneys, GiLiver } from "react-icons/gi";

const PRIMARY = "#0f66a4";

const TREND = [
  { label: "2019 - 2020", value: 54, color: "#3fa535" },
  { label: "2020 - 2021", value: 62, color: "#7d9b1f" },
  { label: "2021 - 2022", value: 71, color: "#f0b429" },
  { label: "2022 - 2023", value: 73, color: "#f57c1f" },
  { label: "2023 - 2024", value: 80, color: "#e0392b" },
];

const CITY_ROWS = [
  { city: "Kanpur", rank: 1, lastRank: 2, change: 5, up: true },
  { city: "Agra", rank: 2, lastRank: 5, change: 7, up: true },
  { city: "Lucknow", rank: 3, lastRank: 1, change: 2, up: false },
  { city: "Prayagraj", rank: 4, lastRank: 3, change: 6, up: false },
  { city: "Noida", rank: 5, lastRank: 4, change: 1, up: false },
];

const CITY_BLOCKS = [
  { title: "5 Outperforming cities jumping the chart" },
  { title: "5 Cities declining on chart" },
  { title: "5 most consistent cities" },
  { title: "5 most volatile cities" },
];

const CityTable = ({ rows }) => (
  <div className="dash-city-table-wrap">
    <table className="dash-city-table">
      <thead>
        <tr>
          <th>City</th>
          <th>Rank</th>
          <th>Last Year Rank</th>
          <th>% Change</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.city}>
            <td>{row.city}</td>
            <td>#{row.rank}</td>
            <td>#{row.lastRank}</td>
            <td>
              <span className={`dash-city-change ${row.up ? "is-up" : "is-down"}`}>
                {row.change}% {row.up ? <FaArrowUp /> : <FaArrowDown />}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const DISEASES = [
  { name: "Mental Health Issues", pct: 0, color: "#22c55e", Icon: FaBrain },
  { name: "Neurological Problems", pct: 4, color: "#22c55e", Icon: GiBrain },
  { name: "Cardiac/Heart Problems", pct: 37.78, color: "#84a521", Icon: FaHeartbeat },
  { name: "Chronic Lung Problems", pct: 1, color: "#22c55e", Icon: FaLungs },
  { name: "Chronic Kidney Problems", pct: 4, color: "#22c55e", Icon: GiKidneys },
  { name: "Chronic Liver Problems", pct: 4, color: "#f57c1f", Icon: GiLiver },
  { name: "Gynaecology Problems", pct: 3, color: "#22c55e", Icon: FaVenus },
  { name: "Cancer Risks", pct: 1, color: "#22c55e", Icon: FaRibbon },
  { name: "Diabetes & Thyroid", pct: 100, color: "#e0392b", Icon: FaTint },
  { name: "Physical Injury & Fall Risk", pct: 0, color: "#22c55e", Icon: FaWheelchair },
  { name: "Osteoporosis & Bone Risk", pct: 4, color: "#22c55e", Icon: FaBone },
  { name: "Pregnancies Problems", pct: 0, color: "#22c55e", Icon: FaBabyCarriage },
  { name: "Vision Problems", pct: 0, color: "#22c55e", Icon: FaEye },
  { name: "ENT Problems", pct: 9, color: "#f0b429", Icon: FaAssistiveListeningSystems },
  { name: "Infertility Problems", pct: 0, color: "#22c55e", Icon: FaVenusMars },
];

const GAUGE_SEGMENTS = [
  { key: "green", start: 205, end: 88, color: "#43b02a" },
  { key: "olive", start: 73, end: 53, color: "#8a9a2b" },
  { key: "orange", start: 38, end: 10, color: "#f2802b" },
  { key: "red", start: -5, end: -25, color: "#e33b2e" },
];

const polar = (cx, cy, r, angleDeg) => {
  const a = (angleDeg * Math.PI) / 180;
  return { x: cx + r * Math.cos(a), y: cy - r * Math.sin(a) };
};

const arcPath = (cx, cy, r, startAngle, endAngle) => {
  const start = polar(cx, cy, r, startAngle);
  const end = polar(cx, cy, r, endAngle);
  const largeArc = Math.abs(endAngle - startAngle) > 180 ? 1 : 0;
  const sweep = startAngle > endAngle ? 1 : 0;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} ${sweep} ${end.x} ${end.y}`;
};

const HealthGauge = () => {
  const cx = 130;
  const cy = 130;
  const r = 100;
  const markerAngle = 80;
  const marker = polar(cx, cy, r, markerAngle);
  return (
    <div className="dash-gauge">
      <svg viewBox="0 0 260 186" className="dash-gauge-svg">
        {GAUGE_SEGMENTS.map((seg) => (
          <path
            key={seg.key}
            d={arcPath(cx, cy, r, seg.start, seg.end)}
            stroke={seg.color}
            strokeWidth="18"
            fill="none"
            strokeLinecap="round"
          />
        ))}
        <path
          d={arcPath(cx, cy, 66, 188, -8)}
          stroke="#6b76e6"
          strokeWidth="2"
          fill="none"
          strokeDasharray="2 7"
          strokeLinecap="round"
        />
        <circle cx={marker.x} cy={marker.y} r="10" fill="#fff" stroke="#3341d0" strokeWidth="4" />
        <text x={cx} y={cy + 14} textAnchor="middle" className="dash-gauge-value">
          Rank 12
        </text>
      </svg>
    </div>
  );
};

const SEC_METRICS = [
  { label: "Population", value: "40.3 Lacs" },
  { label: "Area", value: "140 Sq Km" },
  { label: "Literacy Rate", value: "100%" },
  { label: "Male/ Female Ratio", value: "95:88" },
];

const SEC_CASES = [
  { label: "Suspected", value: "40.3 Lacs" },
  { label: "Under Investigation", value: "40.3 Lacs" },
  { label: "Confirmed", value: "14000" },
  { label: "Undiagnosed", value: "7500" },
];

const TREATMENT_OUTCOMES = [
  { label: "Fully Recovered", value: "40.3 Lacs" },
  { label: "Undergoing Treatments", value: "40.3 Lacs" },
  { label: "Total Mortality", value: "14000" },
  { label: "Disability/ Disorders", value: "7500" },
];

const INDICATORS = [
  { label: "Prevalence Rate", value: "11%" },
  { label: "Recovery Rate", value: "11%" },
  { label: "Mortality Rate", value: "11%" },
  { label: "Case Fatality Rate", value: "11%" },
];

const STATE_RANKINGS = [
  { current: 14, lastYear: 17, change: 3, up: true },
  { current: 17, lastYear: 14, change: 3, up: false },
];

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const LINE_SERIES = [
  { name: "Suspected", color: "#3fa535", data: [30, 45, 25, 55, 40, 58, 48, 68, 44, 62, 52, 72] },
  { name: "Under Investigation", color: "#8a9a2b", data: [52, 42, 60, 46, 64, 50, 68, 55, 74, 60, 78, 68] },
  { name: "Confirmed", color: "#e0392b", data: [22, 30, 26, 36, 30, 40, 34, 44, 40, 50, 44, 54] },
  { name: "Undiagnosed", color: "#f57c1f", data: [12, 16, 20, 15, 26, 20, 30, 24, 34, 30, 40, 34] },
];

const BAR_SERIES = [
  { name: "Suspected", color: "#3fa535" },
  { name: "Under Investigation", color: "#8a9a2b" },
  { name: "Confirmed", color: "#e0392b" },
  { name: "Undiagnosed", color: "#f57c1f" },
];

const BAR_DATA = [
  [20, 15, 8, 5],
  [45, 22, 12, 6],
  [15, 10, 6, 4],
  [10, 8, 5, 3],
  [12, 9, 5, 3],
  [8, 6, 4, 2],
  [14, 10, 6, 4],
  [10, 7, 5, 3],
  [18, 12, 7, 4],
  [24, 15, 9, 5],
  [16, 11, 6, 4],
  [26, 16, 9, 6],
];

const RATIO_BARS = [
  { Icon: FaMale, value: 95, max: 100, color: "#7b6ef0", label: "Male" },
  { Icon: FaFemale, value: 88, max: 100, color: "#ec3ba0", label: "Female" },
];

const LITERACY_BARS = [
  { value: 78, color: "#7b6ef0", label: "Male" },
  { value: 58, color: "#ec3ba0", label: "Female" },
];

const DONUT_STROKE = 20;
const DONUT_RINGS = [
  { r: 94, color: "#3fb54a", portion: 0.72 },
  { r: 73, color: "#f57c1f", portion: 0.6 },
  { r: 52, color: "#e0392b", portion: 0.78 },
];

const ConcentricDonut = () => (
  <svg viewBox="0 0 220 220" className="dash-donut-svg">
    <g transform="rotate(-90 110 110)">
      {DONUT_RINGS.map((ring) => {
        const c = 2 * Math.PI * ring.r;
        return (
          <g key={ring.r}>
            <circle cx="110" cy="110" r={ring.r} fill="none" stroke="#edeef3" strokeWidth={DONUT_STROKE} />
            <circle
              cx="110"
              cy="110"
              r={ring.r}
              fill="none"
              stroke={ring.color}
              strokeWidth={DONUT_STROKE}
              strokeLinecap="round"
              strokeDasharray={`${c * ring.portion} ${c}`}
            />
          </g>
        );
      })}
    </g>
    <circle cx="110" cy="110" r="42" fill="#8a9a2b" />
    <text x="110" y="105" textAnchor="middle" className="dash-donut-label">Area</text>
    <text x="110" y="123" textAnchor="middle" className="dash-donut-value">140 Sq Km</text>
  </svg>
);

const CHART_W = 470;
const CHART_H = 250;
const CHART_PAD = { l: 40, r: 14, t: 14, b: 26 };
const PLOT_W = CHART_W - CHART_PAD.l - CHART_PAD.r;
const PLOT_H = CHART_H - CHART_PAD.t - CHART_PAD.b;
const Y_TICKS = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90];
const Y_MAX = 90;
const yFor = (v) => CHART_PAD.t + (1 - v / Y_MAX) * PLOT_H;

const smoothPath = (pts) => {
  if (pts.length < 2) return "";
  const d = [`M ${pts[0][0]} ${pts[0][1]}`];
  for (let i = 0; i < pts.length - 1; i += 1) {
    const p0 = pts[i - 1] || pts[i];
    const p1 = pts[i];
    const p2 = pts[i + 1];
    const p3 = pts[i + 2] || p2;
    const cp1x = p1[0] + (p2[0] - p0[0]) / 6;
    const cp1y = p1[1] + (p2[1] - p0[1]) / 6;
    const cp2x = p2[0] - (p3[0] - p1[0]) / 6;
    const cp2y = p2[1] - (p3[1] - p1[1]) / 6;
    d.push(`C ${cp1x} ${cp1y} ${cp2x} ${cp2y} ${p2[0]} ${p2[1]}`);
  }
  return d.join(" ");
};

const MultiLineChart = () => {
  const xFor = (i) => CHART_PAD.l + (i / (MONTHS.length - 1)) * PLOT_W;
  const [hover, setHover] = useState(null);
  return (
    <div className="dash-sec-chart">
      <svg viewBox={`0 0 ${CHART_W} ${CHART_H}`} className="dash-sec-chart-svg">
        {Y_TICKS.map((t) => (
          <g key={t}>
            <line x1={CHART_PAD.l} y1={yFor(t)} x2={CHART_W - CHART_PAD.r} y2={yFor(t)} stroke="#eef0f4" />
            <text x={CHART_PAD.l - 6} y={yFor(t) + 3} textAnchor="end" className="dash-sec-axis">
              {t === 0 ? "0" : `${t} L`}
            </text>
          </g>
        ))}
        {MONTHS.map((m, i) => (
          <text key={m} x={xFor(i)} y={CHART_H - 8} textAnchor="middle" className="dash-sec-axis">
            {m}
          </text>
        ))}
        {LINE_SERIES.map((s) => (
          <path
            key={s.name}
            fill="none"
            stroke={s.color}
            strokeWidth="2.5"
            strokeLinejoin="round"
            strokeLinecap="round"
            d={smoothPath(s.data.map((v, i) => [xFor(i), yFor(v)]))}
          />
        ))}
        {LINE_SERIES.map((s) =>
          s.data.map((v, i) => {
            const active = hover && hover.name === s.name && hover.i === i;
            return (
              <circle
                key={`${s.name}-${i}`}
                cx={xFor(i)}
                cy={yFor(v)}
                r={active ? 5 : 3}
                fill={s.color}
                stroke="#fff"
                strokeWidth={active ? 2 : 0}
              />
            );
          })
        )}
        {LINE_SERIES.map((s) =>
          s.data.map((v, i) => (
            <circle
              key={`hit-${s.name}-${i}`}
              cx={xFor(i)}
              cy={yFor(v)}
              r="9"
              fill="transparent"
              className="dash-chart-hit"
              onMouseEnter={() =>
                setHover({ name: s.name, i, x: xFor(i), y: yFor(v), value: v, month: MONTHS[i] })
              }
              onMouseLeave={() => setHover(null)}
            />
          ))
        )}
      </svg>
      {hover && (
        <div
          className="dash-line-tooltip"
          style={{ left: `${(hover.x / CHART_W) * 100}%`, top: `${(hover.y / CHART_H) * 100}%` }}
        >
          <span className="dash-tooltip-head">{hover.month}</span>
          <span>
            {hover.name}: {hover.value} L
          </span>
        </div>
      )}
    </div>
  );
};

const StackedBarChart = () => {
  const band = PLOT_W / MONTHS.length;
  const barW = 12;
  const xCenter = (i) => CHART_PAD.l + band * i + band / 2;
  const [hover, setHover] = useState(null);
  return (
    <div className="dash-sec-chart">
      <svg viewBox={`0 0 ${CHART_W} ${CHART_H}`} className="dash-sec-chart-svg">
        {Y_TICKS.map((t) => (
          <g key={t}>
            <line x1={CHART_PAD.l} y1={yFor(t)} x2={CHART_W - CHART_PAD.r} y2={yFor(t)} stroke="#eef0f4" />
            <text x={CHART_PAD.l - 6} y={yFor(t) + 3} textAnchor="end" className="dash-sec-axis">
              {t === 0 ? "0" : `${t} L`}
            </text>
          </g>
        ))}
        {MONTHS.map((m, i) => (
          <text key={m} x={xCenter(i)} y={CHART_H - 8} textAnchor="middle" className="dash-sec-axis">
            {m}
          </text>
        ))}
        {BAR_DATA.map((segs, i) => {
          let acc = 0;
          return (
            <g key={MONTHS[i]}>
              {segs.map((val, si) => {
                const yTop = yFor(acc + val);
                const yBottom = yFor(acc);
                acc += val;
                return (
                  <rect
                    key={si}
                    x={xCenter(i) - barW / 2}
                    y={yTop}
                    width={barW}
                    height={Math.max(yBottom - yTop, 0)}
                    fill={BAR_SERIES[si].color}
                    opacity={hover != null && hover !== i ? 0.45 : 1}
                  />
                );
              })}
            </g>
          );
        })}
        {MONTHS.map((m, i) => (
          <rect
            key={`hit-${m}`}
            x={CHART_PAD.l + band * i}
            y={CHART_PAD.t}
            width={band}
            height={PLOT_H}
            fill="transparent"
            className="dash-chart-hit"
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(null)}
          />
        ))}
      </svg>
      {hover != null && (
        <div
          className="dash-bar-tooltip"
          style={{
            left: `${(xCenter(hover) / CHART_W) * 100}%`,
            top: `${(yFor(BAR_DATA[hover].reduce((a, b) => a + b, 0)) / CHART_H) * 100}%`,
          }}
        >
          <span className="dash-tooltip-head">{MONTHS[hover]}</span>
          {BAR_SERIES.map((s, si) => (
            <span key={s.name}>
              {s.name}: {BAR_DATA[hover][si]} L
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const RANK_TREND = [30, 40, 37, 34, 44, 40, 30, 44, 52, 58, 66, 74];

const RankSparkline = ({ up }) => {
  const color = up ? "#3aad3f" : "#e0392b";
  const fill = up ? "rgba(58, 173, 63, 0.12)" : "rgba(224, 57, 43, 0.1)";
  const w = 300;
  const h = 110;
  const max = 90;
  const xFor = (i) => (i / (RANK_TREND.length - 1)) * w;
  const yFor = (v) => h - (v / max) * (h - 6) - 3;
  const line = RANK_TREND.map((v, i) => `${xFor(i)},${yFor(v)}`).join(" ");
  const area = `0,${h} ${line} ${w},${h}`;
  return (
    <svg
      className="dash-ind-spark"
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <polygon points={area} fill={fill} />
      <polyline points={line} fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" />
    </svg>
  );
};

const CasesBlock = ({ title, highlight, stats }) => (
  <>
    <div className="dash-sec-cases-title">
      {title} - <span>{highlight}</span>
    </div>
    <div className="dash-sec-group">
      <div className="dash-sec-bottom">
        <div className="dash-sec-stats">
          {stats.map((c) => (
            <div className="dash-sec-stat" key={c.label}>
              <span className="dash-sec-stat-label">{c.label}</span>
              <span className="dash-sec-stat-value">{c.value}</span>
            </div>
          ))}
        </div>

        <div className="dash-sec-charts">
          <div className="dash-sec-legend">
            {LINE_SERIES.map((s) => (
              <span className="dash-sec-legend-item" key={s.name}>
                <i style={{ background: s.color }} />
                {s.name}
              </span>
            ))}
          </div>
          <div className="dash-sec-charts-row">
            <MultiLineChart />
            <StackedBarChart />
          </div>
        </div>
      </div>
    </div>
  </>
);

export const AnalyticsDashboardScreen = () => {
  return (
    <div className="dash-root">
      <DashboardTopbar />

      <div className="dash-body">
        <section className="dash-primary">
          <h2 className="dash-primary-title">Primary Data Information</h2>
          <div className="dash-filters">
            <div className="dash-select">
              <FaMapMarkerAlt className="dash-select-icon" />
              <select defaultValue="" aria-label="Select state name">
                <option value="" disabled>Select state name</option>
                <option>Maharashtra</option>
                <option>Karnataka</option>
                <option>Delhi</option>
              </select>
              <FaChevronDown className="dash-select-caret" />
            </div>

            <div className="dash-select">
              <FaCalendarAlt className="dash-select-icon" />
              <select defaultValue="" aria-label="Select date and time">
                <option value="" disabled>Select date and time</option>
                <option>Last 7 days</option>
                <option>Last 30 days</option>
                <option>This year</option>
              </select>
              <FaChevronDown className="dash-select-caret" />
            </div>

            <div className="dash-gender">
              <label className="dash-check">
                <input type="checkbox" /> <span>Male</span>
              </label>
              <label className="dash-check">
                <input type="checkbox" /> <span>Female</span>
              </label>
            </div>

            <div className="dash-select">
              <FaUsers className="dash-select-icon" />
              <select defaultValue="" aria-label="Select age group">
                <option value="" disabled>Select age group</option>
                <option>0 - 18</option>
                <option>19 - 40</option>
                <option>41 - 60</option>
                <option>60+</option>
              </select>
              <FaChevronDown className="dash-select-caret" />
            </div>

            <button type="button" className="dash-clear">Clear data</button>
          </div>
        </section>

        <section className="dash-metrics">
          <div className="dash-card dash-card--score">
            <span className="dash-card-label">Area wise health score</span>
            <HealthGauge />
            <p className="dash-score-change">
              Changes from last year <strong>+7%</strong>
            </p>
            <p className="dash-score-sub">
              Last year ranking <strong>16</strong>
            </p>
          </div>

          <div className="dash-card dash-card--trend">
            <span className="dash-card-label">5 year trend of health scores</span>
            <div className="dash-chart">
              <div className="dash-chart-yaxis">
                {[100, 90, 80, 70, 60, 50, 40, 30].map((n) => (
                  <span key={n}>{n}</span>
                ))}
              </div>
              <div className="dash-chart-plot">
                <div className="dash-bars">
                  {[100, 90, 80, 70, 60, 50, 40, 30].map((n) => (
                    <span key={n} className="dash-chart-grid" />
                  ))}
                  {TREND.map((t) => (
                    <div className="dash-bar-col" key={t.label}>
                      <div
                        className="dash-bar"
                        style={{ height: `${t.value}%`, background: t.color }}
                      >
                        <span className="dash-bar-value">{t.value}</span>
                      </div>
                      <span className="dash-bar-label">{t.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="dash-card dash-card--actions">
            <div className="dash-actions-head">
              <span>Quick Actions</span>
              <FaChevronRight />
            </div>
            {[0, 1, 2].map((i) => (
              <button type="button" className="dash-action-btn" key={i}>
                <FaDownload />
                Download Health Report
              </button>
            ))}
          </div>

          <button type="button" className="dash-advanced-filter">
            <FaChevronLeft className="dash-advanced-caret" />
            <span className="dash-advanced-text">Advanced Filter</span>
            <FaSlidersH className="dash-advanced-icon" />
          </button>
        </section>

        <section className="dash-disease">
          <div className="dash-disease-head">
            <h3>Disease burden in select geography</h3>
            <button type="button" className="dash-export">
              <FaDownload /> Export Report
            </button>
          </div>

          <div className="dash-disease-grid">
            {DISEASES.map(({ name, pct, color, Icon }) => (
              <div className="dash-disease-card" key={name}>
                <div className="dash-disease-icon" style={{ color: PRIMARY }}>
                  <Icon />
                </div>
                <div className="dash-disease-name">{name}</div>
                <div className="dash-disease-bar">
                  <div className="dash-disease-track">
                    <div
                      className="dash-disease-fill"
                      style={{ width: `${Math.max(Math.min(pct, 100), 9)}%`, background: color }}
                    />
                  </div>
                  <span className="dash-disease-pct">{pct}%</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="dash-city">
          <div className="dash-city-head">
            <h3>City Lists</h3>
            <button type="button" className="dash-export">
              <FaDownload /> Export Report
            </button>
          </div>

          <div className="dash-city-grid">
            <div className="dash-city-block">
              <div className="dash-city-block-title">
                <span className="dash-zone dash-zone--green">Green Zone</span> - Top 5 Cities
              </div>
              <CityTable rows={CITY_ROWS} />
            </div>
            <div className="dash-city-block">
              <div className="dash-city-block-title">
                <span className="dash-zone dash-zone--red">Red Zone</span> - Bottom 5 Cities
              </div>
              <CityTable rows={CITY_ROWS} />
            </div>
          </div>

          <div className="dash-city-divider" />

          <div className="dash-city-grid">
            {CITY_BLOCKS.map((block) => (
              <div className="dash-city-block" key={block.title}>
                <div className="dash-city-block-title dash-city-block-title--muted">
                  {block.title}
                </div>
                <CityTable rows={CITY_ROWS} />
              </div>
            ))}
          </div>
        </section>

        <section className="dash-secondary">
          <h2 className="dash-sec-title">Secondry Data Information</h2>

          <div className="dash-sec-filters">
            <div className="dash-sec-filter">
              <label>Select Disease Category</label>
              <div className="dash-sec-select">
                <FaVirus className="dash-sec-select-icon" />
                <select defaultValue="neuro" aria-label="Select Disease Category">
                  <option value="neuro">Neuropsychiatric and Mental Illness</option>
                  <option value="cardio">Cardiovascular</option>
                  <option value="resp">Respiratory</option>
                </select>
                <FaChevronDown className="dash-sec-select-caret" />
              </div>
            </div>

            <div className="dash-sec-filter">
              <label>Select Sub Category</label>
              <div className="dash-sec-select">
                <select defaultValue="air" aria-label="Select Sub Category">
                  <option value="air">Air Borne</option>
                  <option value="water">Water Borne</option>
                  <option value="vector">Vector Borne</option>
                </select>
                <FaChevronDown className="dash-sec-select-caret" />
              </div>
            </div>

            <div className="dash-sec-filter">
              <label>Subtype</label>
              <div className="dash-sec-select dash-sec-select--readonly">
                <span>COVID 19</span>
              </div>
            </div>

            <button type="button" className="dash-sec-clear">Clear data</button>
          </div>

          <div className="dash-sec-panel">
            <div className="dash-sec-top">
              <div className="dash-sec-metrics">
                {SEC_METRICS.map((m) => (
                  <div className="dash-sec-metric" key={m.label}>
                    <span className="dash-sec-metric-label">{m.label}</span>
                    <span className="dash-sec-metric-value">{m.value}</span>
                  </div>
                ))}
              </div>

              <div className="dash-sec-info">
                <div className="dash-sec-donut">
                  <button type="button" className="dash-sec-menu" aria-label="Options">
                    <FaEllipsisH />
                  </button>
                  <ConcentricDonut />
                  <span className="dash-sec-donut-caption">YTD Data</span>
                </div>

                <div className="dash-sec-ratios">
                  <div className="dash-sec-ratio-group">
                    <span className="dash-sec-ratio-title">Male/ Female Ratio</span>
                    <div className="dash-sec-ratio-body">
                      <div className="dash-sec-ratio-icons">
                        <FaMale className="dash-sec-icon-male" />
                        <FaFemale className="dash-sec-icon-female" />
                      </div>
                      <div className="dash-sec-ratio-bars">
                        {RATIO_BARS.map((b) => (
                          <div className="dash-sec-bar" key={b.label}>
                            <div
                              className="dash-sec-bar-fill"
                              style={{ width: `${b.value}%`, background: b.color }}
                            >
                              <span>{b.value}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="dash-sec-ratio-group">
                    <span className="dash-sec-ratio-title">Literacy Ratio</span>
                    <div className="dash-sec-ratio-body">
                      <div className="dash-sec-ratio-icons">
                        <FaMale aria-label="male" className="dash-sec-icon-male" />
                        <FaFemale aria-label="female" className="dash-sec-icon-female" />
                      </div>
                      <div className="dash-sec-ratio-bars">
                        <div className="dash-sec-literacy-labels">
                          {LITERACY_BARS.map((b) => (
                            <span
                              key={b.label}
                              className={b.label === "Male" ? "dash-sec-label-male" : "dash-sec-label-female"}
                              style={{ flexGrow: b.value }}
                            >
                              {b.label}
                            </span>
                          ))}
                        </div>
                        <div className="dash-sec-literacy">
                          {LITERACY_BARS.map((b) => (
                            <div
                              className="dash-sec-literacy-bar"
                              key={b.label}
                              style={{ background: b.color, flexGrow: b.value }}
                            >
                              {b.value}%
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="dash-sec-cases-title">
              New Reported Cases - <span>YTD</span>
            </div>

            <div className="dash-sec-bottom">
              <div className="dash-sec-stats">
                {SEC_CASES.map((c) => (
                  <div className="dash-sec-stat" key={c.label}>
                    <span className="dash-sec-stat-label">{c.label}</span>
                    <span className="dash-sec-stat-value">{c.value}</span>
                  </div>
                ))}
              </div>

              <div className="dash-sec-charts">
                <div className="dash-sec-legend">
                  {LINE_SERIES.map((s) => (
                    <span className="dash-sec-legend-item" key={s.name}>
                      <i style={{ background: s.color }} />
                      {s.name}
                    </span>
                  ))}
                </div>
                <div className="dash-sec-charts-row">
                  <MultiLineChart />
                  <StackedBarChart />
                </div>
              </div>
            </div>

            <CasesBlock title="Total Reported Cases" highlight="Overall" stats={SEC_CASES} />

            <CasesBlock title="Treatment Outcomes" highlight="YTD" stats={TREATMENT_OUTCOMES} />

            <div className="dash-sec-cases-title">
              Disease Indicators - <strong className="dash-ind-title-strong">Nation Wise Result</strong>
            </div>
            <div className="dash-ind-rows">
              {STATE_RANKINGS.map((r, idx) => (
                <div className="dash-ind-row" key={idx}>
                  <div className="dash-ind-cards">
                    {INDICATORS.map((it) => (
                      <div className="dash-ind-card" key={it.label}>
                        <span className="dash-ind-label">{it.label}</span>
                        <span className="dash-ind-value">{it.value}</span>
                      </div>
                    ))}
                  </div>

                  <div className="dash-ind-ranking">
                    <span className="dash-ind-ranking-title">State Ranking</span>
                    <div className="dash-ind-ranking-card">
                      <div className="dash-ind-ranking-info">
                        <span>Current Rank: <strong>#{r.current}</strong></span>
                        <span>Last Year: <strong>#{r.lastYear}</strong></span>
                        <span>
                          Change: <strong>{r.up ? "+" : "-"}{r.change}%</strong>
                        </span>
                      </div>
                      <div className="dash-ind-ranking-badge">
                        <RankSparkline up={r.up} />
                        <span className={`dash-ind-badge-val ${r.up ? "is-up" : "is-down"}`}>
                          {r.up ? <FaArrowUp /> : <FaArrowDown />}
                          {r.change}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AnalyticsDashboardScreen;
